import React, { useContext } from 'react';
import { SentenceTreeItem } from 'routes/Explore/components/Sentence/components/TreeDropdown';

export type TreeValue = SentenceTreeItem['field'];

type ContextType = {
    currentValues: TreeValue[];
    setCurrentValues: React.Dispatch<React.SetStateAction<TreeValue[]>>;
};

const initialContext: ContextType = {
    currentValues: [],
    setCurrentValues: () => {},
};
const TreeValueContext = React.createContext<ContextType>(initialContext);

export const useTreeValue = () => useContext(TreeValueContext);

export default TreeValueContext;
